import React, { useState, useEffect, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useQuery } from '@apollo/react-hooks';
import { GET_USER } from 'graphql/Home';
import MicOffIcon from '@material-ui/icons/MicOff';
import MicIcon from '@material-ui/icons/Mic';
import VideocamIcon from '@material-ui/icons/Videocam';
import VideocamOffIcon from '@material-ui/icons/VideocamOff';
import styles from './styles';

const Participant = ({ participant, isLocal, layout, dominantSpeaker, setDominantSpeaker }) => {
  const [videoTracks, setVideoTracks] = useState([]);
  const [audioTracks, setAudioTracks] = useState([]);
  const [isMuted, setIsMuted] = useState(true);
  const [videoOff, setVideoOff] = useState(true);
  const videoRef = useRef();
  const audioRef = useRef();
  const { data } = useQuery(GET_USER, {
    variables: { sub: participant.identity },
  });

  useEffect(() => {
    if (isMuted) {
      if (dominantSpeaker === participant) {
        setDominantSpeaker(null);
      }
    }
  }, [isMuted]);

  const isBorder = dominantSpeaker === participant;

  const user = data?.user[0] || null;

  const trackPublished = (publication) => {
    console.log(
      `RemoteParticipant ${participant.identity} published a RemoteTrack: ${publication}`,
    );

    publication.on('subscribed', (track) => {
      console.log(`LocalParticipant subscribed to a RemoteTrack: ${track}`);
      if (publication.isSubscribed) {
        if (track.kind === 'video' && track.name !== 'screen') {
          setVideoTracks((videoTracks) => [...videoTracks, publication]);
          setVideoOff(!track.isEnabled);
          track.on('disabled', (track) => {
            setVideoOff(true);
          });
          track.on('enabled', (track) => {
            setVideoOff(false);
          });
        } else if (track.kind === 'audio') {
          setAudioTracks((audioTracks) => [...audioTracks, publication]);
          setIsMuted(!track.isEnabled);
          track.on('disabled', (track) => {
            setIsMuted(true);
          });
          track.on('enabled', (track) => {
            setIsMuted(false);
          });
        }
        console.log('subscribed', track);
      }
    });

    publication.on('unsubscribed', (track) => {
      console.log(`LocalParticipant unsubscribed from a RemoteTrack: ${track}`);
      if (track.kind === 'video') {
        setVideoTracks((videoTracks) =>
          videoTracks.filter((v) => v !== publication),
        );
      } else {
        setAudioTracks((audioTracks) =>
          audioTracks.filter((a) => a !== publication),
        );
      }
    });

    // publication.on('trackDisabled', (track) => {
    //   console.log('track disabled', track);
    // });
    //
    // publication.on('trackEnabled', (track) => {
    //   console.log('track enabled', track);
    // });
  };

  useEffect(() => {
    setVideoTracks(Array.from(participant.videoTracks.values()));
    setAudioTracks(Array.from(participant.audioTracks.values()));

    participant.tracks.forEach((publication) => {
      trackPublished(publication);
    });

    participant.on('trackPublished', (publication) => {
      trackPublished(publication);
      if (isLocal) {
        if (
          publication.track.kind === 'video' &&
          publication.track.name !== 'screen'
        ) {
          publication.track.attach(videoRef.current);
        }
      }
      setVideoOff(false);
    });

    participant.on('trackUnpublished', (publication) => {
      console.log(
        `RemoteParticipant ${participant.identity} unpublished a RemoteTrack: ${publication}`,
        publication,
      );
      setVideoOff(true);
      publication.track && publication.track.detach();
    });

    return () => {
      setVideoTracks([]);
      setAudioTracks([]);
      participant.removeAllListeners();
    };
  }, []);

  useEffect(() => {
    const videoTrack = videoTracks.find((i) => i.trackName !== 'screen');
    if (videoTrack) {
      if (isLocal || videoTrack.isSubscribed) {
        videoTrack.track.attach(videoRef.current);
      }
    }
    return () => {
      videoTrack && videoTrack.track && videoTrack.track.detach();
    };
  }, [videoTracks]);

  useEffect(() => {
    const audioTrack = audioTracks[0];
    if (audioTrack) {
      if (isLocal || audioTrack.isSubscribed) {
        audioTrack.track.attach(audioRef.current);
      }
    }
    return () => {
      audioTrack && audioTrack.track && audioTrack.track.detach();
    };
  }, [audioTracks]);

  const style = {
    transform: 'rotateY(180deg)',
    border: isBorder && '4px #eb5e28 solid',
  };

  return (
    <div className="participant" style={layout}>
      <video ref={videoRef} autoPlay={true} style={style} />
      <audio ref={audioRef} autoPlay={true} muted={false} />
      <div className="video-details">
        {user && (
          <div className="username">
            {user.user_first_name} {user.user_last_name}
          </div>
        )}
        <div className="video-icons">
          <div className={isMuted ? 'mic-off' : 'mic-on'}>
            {!isLocal &&
              (isMuted ? (
                <MicOffIcon fontSize="small" />
              ) : (
                <MicIcon fontSize="small" />
              ))}
          </div>
          <div className={videoOff ? 'mic-off' : 'mic-on'}>
            {!isLocal &&
              (videoOff ? (
                <VideocamOffIcon fontSize="small" />
              ) : (
                <VideocamIcon fontSize="small" />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(Participant);
